import { render } from "./freeSharesIssuance.vue?vue&type=template&id=019bb41e&scoped=true"
import script from "./freeSharesIssuance.vue?vue&type=script&lang=ts"
export * from "./freeSharesIssuance.vue?vue&type=script&lang=ts"

import "./freeSharesIssuance.vue?vue&type=style&index=0&id=019bb41e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-019bb41e"

export default script